import {
  FiHome,
  FiUser,
  FiUsers,
  FiPieChart,
  FiActivity,
  FiSettings,
  FiGrid,
} from 'react-icons/fi';
import { LuDoorOpen } from 'react-icons/lu';
import { ROLES } from '../../models/roles';

/**
 * Devuelve los ítems de la navegación inferior según el rol del usuario
 * autenticado. Centralizar esto acá evita repetir el arreglo en cada vista.
 */
export function getNavItems(role) {
  switch (role) {
    case ROLES.DATA_ENTRY:
      return [
        { to: '/data-entry', label: 'Inicio', icon: <FiGrid />, end: true },
        { to: '/data-entry/house-registration', label: 'Nueva vivienda', icon: <FiHome /> },
        { to: '/data-entry/houses', label: 'Registrar visita', icon: <LuDoorOpen /> },
        { to: '/profile', label: 'Perfil', icon: <FiUser /> },
      ];
    case ROLES.ANALYST:
      return [
        { to: '/analyst', label: 'Inicio', icon: <FiHome />, end: true },
        { to: '/analyst/reports', label: 'Reportes', icon: <FiPieChart /> },
        { to: '/analyst/activity', label: 'Actividad', icon: <FiActivity /> },
        { to: '/profile', label: 'Perfil', icon: <FiUser /> },
      ];
    case ROLES.ADMIN:
      return [
        { to: '/admin', label: 'Inicio', icon: <FiHome />, end: true },
        { to: '/admin/users', label: 'Usuarios', icon: <FiUsers /> },
        { to: '/admin/forms', label: 'Formularios', icon: <FiSettings /> },
        { to: '/profile', label: 'Perfil', icon: <FiUser /> },
      ];
    default:
      return [];
  }
}
